// Footer.js
import React from "react";
import {
  FaFacebookF,
  FaWhatsapp,
  FaYoutube,
  FaInstagram,
  FaTwitter,
} from "react-icons/fa";

// --- Data Structures ---
const quickLinks = [
  { name: "About Us", href: "/about" },
  { name: "FAQ", href: "/faq" },
  { name: "Privacy Policy", href: "/privacy" },
  { name: "Terms & Conditions", href: "/terms" },
  { name: "Contact Us", href: "/contact" },
];

// Define styles/colors for social icons based on the image
const socialLinks = [
  { Icon: "/images/social-icon1.svg" },
  { Icon: "/images/social-icon2.svg" },
  { Icon: "/images/social-icon3.svg" },
  { Icon: "/images/social-icon4.svg" },
  { Icon: "/images/social-icon5.svg" },
];

const UserFooter = () => {
  return (
    // Outer container with light gray background and padding
    <footer className="bg-gray-100 py-12 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Grid Layout for Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-12">
          {/* 1. Branding Section (Logo and Description) */}
          <div className="md:col-span-1 lg:col-span-2 space-y-4">
            {/* Logo/Branding */}
            <div className="flex flex-col items-start space-y-1">
              <img src="/images/footer-logo.svg" alt="footer-logo" />
            </div>

            {/* Description Text */}
            <p className="web-body-md text-gray-600 !leading-relaxed max-w-sm">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>

          {/* 2. Quick Links Section */}
          <div className="space-y-4">
            <h3 className="web-h4 text-gray-950 mb-4">Quick Links</h3>
            <ul className="space-y-5 !list-none p-0">
              {/* Mapping through the quickLinks array */}
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="web-body-lg text-gray-950 hover:text-[#DEA916] !no-underline transition-colors duration-200 text-base"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 3. Social Media Section */}
          <div className="space-y-4">
            <h3 className="web-h4 text-gray-950 mb-4">Social Media</h3>
            <div className="flex space-x-3">
              {/* Mapping through the socialLinks array */}
              {socialLinks.map(({ Icon, href }) => (
                <a
                  key={Icon}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Icon} alt="" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default UserFooter;
